require('../modules/web.timers');
var path = require('../internals/path');

module.exports = path.setTimeout;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/core-js-pure/stable/set-timeout.js
// module id = 2744
// module chunks = 1